const { fetchAdsl } = require('api');
const { useQuery } = require('react-query');

const useAdslFetch = () => {
  return useQuery({
    queryKey: ['adsl'],
    queryFn: fetchAdsl,
  });
};
export default useAdslFetch;
